


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useStickerSectionStore } from "../EditorStore";
import { faBars } from "@fortawesome/free-solid-svg-icons";

export default function ToggleStickerSectionButton() {
    const showStickersSection = useStickerSectionStore((state) => state.showStickersSection);
    const setShowStickersSection = useStickerSectionStore((state) => state.setShowStickersSection);

    const iconButtonStyle = (): React.CSSProperties => ({
        height: "100%",
        width: "80%",
        marginTop: "0",
        backgroundSize: "contain",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid white",
        borderBottom: "none",
        borderTopRightRadius: "10px",
        borderTopLeftRadius: "10px",
        backgroundColor: "rgba(0, 0, 0, 0.7)",



    });

    return (
        <div style={{
            height: "100%", width: "25%", display: "flex", flexDirection: "row", justifyContent: "center", touchAction: "none", pointerEvents: "auto", WebkitTapHighlightColor: "transparent"
        }}
            onClick={() => {
                setShowStickersSection(!showStickersSection);
            }}
        >
            <div
                id="toggle-switch"
                style={iconButtonStyle()}
            > <FontAwesomeIcon icon={faBars} color="white" style={{ height: "70%", width: "70%", pointerEvents: "none" }} /> </div>
        </div>
    );
}